var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4626_15592",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4626_15592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50008 11.1669H8.50008V7.33354H7.50008V11.1669ZM8.00008 6.19254C8.15264 6.19254 8.28053 6.14093 8.38375 6.0377C8.48697 5.93448 8.53858 5.80659 8.53858 5.65404C8.53858 5.50148 8.48697 5.37359 8.38375 5.27037C8.28053 5.16726 8.15264 5.1157 8.00008 5.1157C7.84753 5.1157 7.71964 5.16726 7.61641 5.27037C7.51319 5.37359 7.46158 5.50148 7.46158 5.65404C7.46158 5.80659 7.51319 5.93448 7.61641 6.0377C7.71964 6.14093 7.84753 6.19254 8.00008 6.19254ZM8.00125 14.3335C7.12525 14.3335 6.30186 14.1673 5.53108 13.8349C4.7603 13.5024 4.08986 13.0513 3.51975 12.4814C2.94964 11.9115 2.49825 11.2413 2.16558 10.4709C1.83303 9.70043 1.66675 8.87726 1.66675 8.00137C1.66675 7.12537 1.83297 6.30198 2.16541 5.5312C2.49786 4.76043 2.94903 4.08998 3.51891 3.51987C4.0888 2.94976 4.75897 2.49837 5.52941 2.1657C6.29986 1.83315 7.12303 1.66687 7.99891 1.66687C8.87491 1.66687 9.6983 1.83309 10.4691 2.16554C11.2399 2.49798 11.9103 2.94915 12.4804 3.51904C13.0505 4.08893 13.5019 4.75909 13.8346 5.52954C14.1671 6.29998 14.3334 7.12315 14.3334 7.99904C14.3334 8.87504 14.1672 9.69843 13.8347 10.4692C13.5023 11.24 13.0511 11.9104 12.4812 12.4805C11.9114 13.0506 11.2412 13.502 10.4707 13.8347C9.7003 14.1673 8.87714 14.3335 8.00125 14.3335ZM8.00008 13.3335C9.48897 13.3335 10.7501 12.8169 11.7834 11.7835C12.8167 10.7502 13.3334 9.48909 13.3334 8.0002C13.3334 6.51131 12.8167 5.2502 11.7834 4.21687C10.7501 3.18354 9.48897 2.66687 8.00008 2.66687C6.51119 2.66687 5.25008 3.18354 4.21675 4.21687C3.18341 5.2502 2.66675 6.51131 2.66675 8.0002C2.66675 9.48909 3.18341 10.7502 4.21675 11.7835C5.25008 12.8169 6.51119 13.3335 8.00008 13.3335Z",
    fill: "#151515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.843b87cc7d962178e6736e669b0186d5.svg";
export { ForwardRef as ReactComponent };